import { useContext, useEffect, useState } from "react";

import { FormType } from "@simplyk/common";
import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

import { IS_PREVIEW_QUERY_PARAM } from "../../../constants/url";
import { useCurrentUserContext } from "../../../contexts/CurrentUserContext";
import { FrontendFormContext } from "../../../contexts/FrontendFormContext";
import { useIsIframe } from "../../../hooks/useIsIframe";
import { useIsOnboarding } from "../../../hooks/useIsOnboarding";

type StoredFormData = {
  formId: string;
  token: string;
};
import { getObjectFromLocalStorage } from "@/helpers/localStorage";

export const useShouldDisplayFormOwnerBanner = () => {
  const { organization: userOrg, userIsLoading } = useCurrentUserContext();
  const { formType, formData } = useContext(FrontendFormContext);
  const search = useSearchParams();
  const router = useRouter();
  const { isOnboarding } = useIsOnboarding();
  const isIframe = useIsIframe();
  const [storedData, setStoredData] = useState<StoredFormData>({ formId: "", token: "" });

  useEffect(() => {
    // Only access localStorage in the browser
    const storedData: StoredFormData | undefined = getObjectFromLocalStorage?.("peer-to-peer-form-data");
    if (storedData) {
      setStoredData(storedData);
    }
  }, [formData.id]);

  const isPreviewTemplateMode = router.query.previewTemplateMode === "true";
  const isPreview = search.get(IS_PREVIEW_QUERY_PARAM) === "true" || false;

  const formOrg = formData.organization;
  const isOwner = formOrg && userOrg && formOrg?.id === userOrg.id;

  const paymentFormTypes = [FormType.DonationForm, FormType.Ticketing];
  const isPaymentForm = formType && paymentFormTypes.includes(formType);

  const isFormPageDonorView = formData.id;

  // When a non logged in user creates a P2P campaign, we store the formId and token in local storage
  // And we use it to display the edit and copy share link buttons
  const isPeerToPeerCreator = storedData.formId === formData.id && !!storedData.token;

  return {
    isLoading: userIsLoading,
    isPeerToPeerCreator,
    token: storedData.token,
    shouldDisplayFormOwnerBanner:
      (isOwner || isPeerToPeerCreator) &&
      !isOnboarding &&
      !isPreviewTemplateMode &&
      !isPreview &&
      !isIframe &&
      isPaymentForm &&
      isFormPageDonorView,
  };
};
